import { render, staticRenderFns } from "./registration_layouts.vue?vue&type=template&id=38a124d0&"
import script from "./registration_layouts.vue?vue&type=script&lang=js&"
export * from "./registration_layouts.vue?vue&type=script&lang=js&"
import style0 from "./registration_layouts.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports